import React, { useEffect, useState } from "react";
import "./Contact.css";
import contactImg from "../../assets/images/Contact Image.png";
import { useNavigate } from "react-router-dom";

const faqs = [
  {
    question: "How can I contact you?",
    answer: "You can fill out the form on this page, and I'll get back to you via email."
  },
  {
    question: "Do you offer freelance services?",
    answer: "Yes, I'm open to freelance opportunities. Please mention your project details in the message box."
  },
  {
    question: "What is your response time?",
    answer: "I typically respond within 24-48 hours."
  }
];

const Contact = () => {
  const navigate = useNavigate();

  const API_URL = process.env.REACT_APP_API_URL;

  const [agree, setAgree] = useState(false);
  const [openFaqIndex, setOpenFaqIndex] = useState(null);

  const [turnstileToken, setTurnstileToken] = useState("");
  const [loading, setLoading] = useState(false);
  const [serverMsg, setServerMsg] = useState("");
  const [errorMsg, setErrorMsg] = useState("");

  const [formData, setFormData] = useState({
    firstName: "",
    lastName: "",
    email: "",
    countryCode: "select",
    mobile: "",
    country: "",
    state: "",
    city: "",
    message: ""
  });

  const toggleFAQ = (index) => {
    setOpenFaqIndex(openFaqIndex === index ? null : index);
  };

  const handleChange = (e) => {
    const { name, value } = e.target;

    if (name === "mobile") {
      const numericValue = value.replace(/\D/g, "").slice(0, 10);
      setFormData((prev) => ({
        ...prev,
        mobile: numericValue
      }));
      setErrorMsg("");
      setServerMsg("");
      return;
    }

    setFormData((prev) => ({
      ...prev,
      [name]: value
    }));

    setErrorMsg("");
    setServerMsg("");
  };

  // Load Turnstile widget
  useEffect(() => {
    const turnstileScript = document.createElement("script");
    turnstileScript.src = "https://challenges.cloudflare.com/turnstile/v0/api.js";
    turnstileScript.async = true;
    turnstileScript.defer = true;
    document.body.appendChild(turnstileScript);

    const interval = setInterval(() => {
      if (window.turnstile && document.getElementById("turnstile-widget")) {
        window.turnstile.render("#turnstile-widget", {
          sitekey: "0x4AAAAAABaVGCmmFZsKUxj3",
          theme: "light",
          callback: function (token) {
            setTurnstileToken(token);
          }
        });
        clearInterval(interval);
      }
    }, 300);

    return () => clearInterval(interval);
  }, []);

  const validateForm = () => {
    if (!formData.firstName.trim()) return "First Name is required";
    if (!formData.lastName.trim()) return "Last Name is required";
    if (!formData.email.trim()) return "Email is required";
    if (!formData.mobile.trim()) return "Mobile Number is required";
    if (formData.countryCode === "select") return "Please select country code";
    if (!formData.country.trim()) return "Please select country";
    if (!formData.state.trim()) return "Please select state";
    if (!formData.city.trim()) return "Please select city";
    if (!formData.message.trim()) return "Message is required";

    if (!agree) return "Please agree to the Terms & Conditions";
    if (!turnstileToken) return "Please verify the Turnstile captcha";

    if (!API_URL) return "API URL is missing. Please contact admin.";

    return null;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    setErrorMsg("");
    setServerMsg("");

    const validationError = validateForm();
    if (validationError) {
      setErrorMsg(validationError);
      return;
    }

    setLoading(true);

    try {
      const payload = {
        firstName: formData.firstName,
        lastName: formData.lastName,
        email: formData.email,
        countryCode: formData.countryCode,
        mobile: formData.mobile,
        country: formData.country,
        state: formData.state,
        city: formData.city,
        message: formData.message,
        turnstileToken: turnstileToken
      };

      const response = await fetch(`${API_URL}/api/contact`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json"
        },
        body: JSON.stringify(payload)
      });

      if (!response.ok) {
        const errorText = await response.text();
        setErrorMsg(errorText || "Something went wrong. Please try again.");
        setLoading(false);
        return;
      }

      const data = await response.json();

      setServerMsg(data?.message || "Success! Your message has been submitted.");

      setFormData({
        firstName: "",
        lastName: "",
        email: "",
        countryCode: "select",
        mobile: "",
        country: "",
        state: "",
        city: "",
        message: ""
      });

      setAgree(false);
      setTurnstileToken("");

      setTimeout(() => {
        navigate("/thank-you");
      }, 800);

    } catch (error) {
      console.error(error);
      setErrorMsg("Network Error. Please try again later.");
    }

    setLoading(false);
  };

  return (
    <div className="contact-container">
      <h1 className="contact-heading">
        <span className="multi-color-text">Contact</span> Me
      </h1>

      <div className="contact-content">
        <div className="contact-left">
          <img src={contactImg} alt="Contact" />
        </div>

        <form className="contact-form" onSubmit={handleSubmit}>
          <p className="required-note">* Indicates required question</p>

          <input
            type="text"
            name="firstName"
            placeholder="Enter Your First Name *"
            value={formData.firstName}
            onChange={handleChange}
            required
          />

          <input
            type="text"
            name="lastName"
            placeholder="Enter Your Last Name *"
            value={formData.lastName}
            onChange={handleChange}
            required
          />

          <input
            type="email"
            name="email"
            placeholder="Enter Your Email Address *"
            value={formData.email}
            onChange={handleChange}
            required
          />

          <div className="mobile-field">
            <select
              name="countryCode"
              value={formData.countryCode}
              onChange={handleChange}
              required
            >
              <option value="select">Select</option>
              <option value="+1">+1</option>
<option value="+91">+91</option>
<option value="+7">+7</option>
<option value="+20">+20</option>
<option value="+27">+27</option>
<option value="+30">+30</option>
<option value="+31">+31</option>
<option value="+32">+32</option>
<option value="+33">+33</option>
<option value="+34">+34</option>
<option value="+36">+36</option>
<option value="+39">+39</option>
<option value="+40">+40</option>
<option value="+41">+41</option>
<option value="+43">+43</option>
<option value="+44">+44</option>
<option value="+45">+45</option>
<option value="+46">+46</option>
<option value="+47">+47</option>
<option value="+48">+48</option>
<option value="+49">+49</option>
<option value="+51">+51</option>
<option value="+52">+52</option>
<option value="+53">+53</option>
<option value="+54">+54</option>
<option value="+55">+55</option>
<option value="+56">+56</option>
<option value="+57">+57</option>
<option value="+58">+58</option>
<option value="+60">+60</option>
<option value="+61">+61</option>
<option value="+62">+62</option>
<option value="+63">+63</option>
<option value="+64">+64</option>
<option value="+65">+65</option>
<option value="+66">+66</option>
<option value="+81">+81</option>
<option value="+82">+82</option>
<option value="+84">+84</option>
<option value="+86">+86</option>
<option value="+90">+90</option>
<option value="+91">+91</option>
<option value="+92">+92</option>
<option value="+93">+93</option>
            </select>

            <input
              type="tel"
              name="mobile"
              placeholder="Enter Your Mobile Number *"
              value={formData.mobile}
              onChange={handleChange}
              maxLength={10}
              required
            />
          </div>

          {formData.mobile.length === 10 && (
            <p className="mobile-warning">Only 10 Digits Allowed</p>
          )}

          <select name="country" value={formData.country} onChange={handleChange} required>
            <option value="">---Select Country--- *</option>
            <option value="AL">Albania</option>
<option value="DZ">Algeria</option>
<option value="AS">American Samoa</option>
<option value="AD">Andorra</option>
<option value="AO">Angola</option>
<option value="AI">Anguilla</option>
<option value="AQ">Antarctica</option>
<option value="HK">Hong Kong</option>
<option value="HU">Hungary</option>
<option value="IS">Iceland</option>
<option value="IN">India</option>
<option value="ID">Indonesia</option>
<option value="IR">Iran</option>
<option value="IQ">Iraq</option>
<option value="IE">Ireland</option>
<option value="IM">Isle of Man</option>
<option value="IL">Israel</option>
<option value="IT">Italy</option>
<option value="JM">Jamaica</option>
<option value="JP">Japan</option>
<option value="MY">Malaysia</option>
<option value="MV">Maldives</option>
<option value="MM">Myanmar</option>
<option value="NA">Namibia</option>
<option value="NR">Nauru</option>
<option value="NP">Nepal</option>
<option value="NL">Netherlands</option>
<option value="NC">New Caledonia</option>
<option value="NZ">New Zealand</option>
<option value="NI">Nicaragua</option>
<option value="NE">Niger</option>
<option value="NG">Nigeria</option>
<option value="NU">Niue</option>
<option value="NF">Norfolk Island</option>
<option value="MK">North Macedonia</option>
<option value="MP">Northern Mariana Islands</option>
<option value="NO">Norway</option>
<option value="OM">Oman</option>
<option value="PK">Pakistan</option>
<option value="PW">Palau</option>
<option value="PS">Palestine</option>
<option value="PA">Panama</option>
<option value="PG">Papua New Guinea</option>
<option value="PY">Paraguay</option>
<option value="PE">Peru</option>
<option value="PH">Philippines</option>
<option value="PN">Pitcairn</option>
<option value="PL">Poland</option>
<option value="PT">Portugal</option>
<option value="PR">Puerto Rico</option>
<option value="QA">Qatar</option>
<option value="RO">Romania</option>
<option value="RU">Russia</option>
<option value="RW">Rwanda</option>
<option value="RE">Réunion</option>
<option value="BL">Saint Barthélemy</option>
<option value="SH">Saint Helena</option>
<option value="KN">Saint Kitts and Nevis</option>
<option value="LC">Saint Lucia</option>
<option value="MF">Saint Martin</option>
<option value="PM">Saint Pierre and Miquelon</option>
<option value="VC">Saint Vincent and the Grenadines</option>
<option value="WS">Samoa</option>
<option value="SM">San Marino</option>
<option value="ST">Sao Tome and Principe</option>
<option value="SA">Saudi Arabia</option>
<option value="SN">Senegal</option>
<option value="RS">Serbia</option>
<option value="SC">Seychelles</option>
<option value="SL">Sierra Leone</option>
<option value="SG">Singapore</option>
<option value="SX">Sint Maarten</option>
<option value="SK">Slovakia</option>
<option value="SI">Slovenia</option>
<option value="SB">Solomon Islands</option>
<option value="SO">Somalia</option>
<option value="ZA">South Africa</option>
<option value="GS">South Georgia</option>
<option value="SS">South Sudan</option>
<option value="ES">Spain</option>
<option value="LK">Sri Lanka</option>
<option value="SD">Sudan</option>
<option value="SR">Suriname</option>
<option value="SJ">Svalbard and Jan Mayen</option>
<option value="SE">Sweden</option>
<option value="CH">Switzerland</option>
<option value="AE">United Arab Emirates</option>
<option value="GB">United Kingdom</option>
<option value="US">United States</option>
<option value="UM">United States Minor Outlying Islands</option>
<option value="UY">Uruguay</option>
<option value="UZ">Uzbekistan</option>
<option value="EH">Western Sahara</option>
<option value="YE">Yemen</option>
<option value="ZM">Zambia</option>
<option value="ZW">Zimbabwe</option>
          </select>

          <select name="state" value={formData.state} onChange={handleChange} required>
            <option value="">---Select State--- *</option>
           <option value="AR">Arunachal Pradesh</option>
<option value="AS">Assam</option>
<option value="BR">Bihar</option>
<option value="CT">Chhattisgarh</option>
<option value="GA">Goa</option>
<option value="GJ">Gujarat</option>
<option value="HR">Haryana</option>
<option value="HP">Himachal Pradesh</option>
<option value="JH">Jharkhand</option>
<option value="KA">Karnataka</option>
<option value="KL">Kerala</option>
<option value="MP">Madhya Pradesh</option>
<option value="MH">Maharashtra</option>
<option value="MN">Manipur</option>
<option value="ML">Meghalaya</option>
<option value="MZ">Mizoram</option>
<option value="NL">Nagaland</option>
<option value="OR">Odisha</option>
<option value="PB">Punjab</option>
<option value="RJ">Rajasthan</option>
<option value="SK">Sikkim</option>
<option value="TN">Tamil Nadu</option>
<option value="TG">Telangana</option>
<option value="TR">Tripura</option>
<option value="UP">Uttar Pradesh</option>
<option value="UT">Uttarakhand</option>
<option value="WB">West Bengal</option>
<option value="AN">Andaman and Nicobar Islands</option>
<option value="CH">Chandigarh</option>
<option value="DN">Dadra and Nagar Haveli and Daman and Diu</option>
<option value="DL">Delhi</option>
<option value="JK">Jammu and Kashmir</option>
<option value="LA">Ladakh</option>
<option value="LD">Lakshadweep</option>
<option value="PY">Puducherry</option>
          </select>

          <select name="city" value={formData.city} onChange={handleChange} required>
            <option value="">---Select City--- *</option>
           <option value="Chennai">Chennai</option>
<option value="Coimbatore">Coimbatore</option>
<option value="Dharapuram">Dharapuram</option>
<option value="Madurai">Madurai</option>
<option value="Banglore">Banglore</option>
<option value="Hyderabad">Hyderabad</option>
<option value="Tiruchirappalli">Tiruchirappalli</option>
<option value="Salem">Salem</option>
<option value="Tirunelveli">Tirunelveli</option>
<option value="Erode">Erode</option>
<option value="Vellore">Vellore</option>
<option value="Tirupur">Tirupur</option>
<option value="Dindigul">Dindigul</option>
<option value="Thoothukudi">Thoothukudi</option>
<option value="Kanchipuram">Kanchipuram</option>
<option value="Cuddalore">Cuddalore</option>
<option value="Karur">Karur</option>
<option value="Pudukkottai">Pudukkottai</option>
<option value="Nagercoil">Nagercoil</option>
<option value="Krishnagiri">Krishnagiri</option>
<option value="Nagapattinam">Nagapattinam</option>
<option value="Villupuram">Villupuram</option>
<option value="Arakkonam">Arakkonam</option>
<option value="Kumbakonam">Kumbakonam</option>
<option value="Sivakasi">Sivakasi</option>
<option value="Ramanathapuram">Ramanathapuram</option>
<option value="Ambur">Ambur</option>
<option value="Coonoor">Coonoor</option>
<option value="Pollachi">Pollachi</option>
<option value="Perambalur">Perambalur</option>
<option value="Rajapalayam">Rajapalayam</option>
<option value="Bhavani">Bhavani</option>
<option value="Mettur">Mettur</option>
<option value="Vickramasingapuram">Vickramasingapuram</option>
<option value="Ariyalur">Ariyalur</option>
<option value="Chidambaram">Chidambaram</option>
<option value="Sirkali">Sirkali</option>
<option value="Tiruvannamalai">Tiruvannamalai</option>
<option value="Karaikudi">Karaikudi</option>
<option value="Nellai">Nellai</option>
<option value="Thanjavur">Thanjavur</option>
<option value="Thiruvananthapuram">Thiruvananthapuram</option>
<option value="Kochi">Kochi</option>
<option value="Kozhikode">Kozhikode</option>
<option value="Thrissur">Thrissur</option>
<option value="Kottayam">Kottayam</option>
<option value="Alappuzha">Alappuzha</option>
<option value="Kannur">Kannur</option>
<option value="Malappuram">Malappuram</option>
<option value="Palakkad">Palakkad</option>
<option value="Pathanamthitta">Pathanamthitta</option>
<option value="Idukki">Idukki</option>
<option value="Wayanad">Wayanad</option>
<option value="Kollam">Kollam</option>
<option value="Punalur">Punalur</option>
<option value="Muvattupuzha">Muvattupuzha</option>
<option value="Changanassery">Changanassery</option>
<option value="Perumbavoor">Perumbavoor</option>
<option value="Varkala">Varkala</option>
<option value="Attingal">Attingal</option>
<option value="Payyannur">Payyannur</option>
<option value="Mattancherry">Mattancherry</option>
          </select>

          <textarea
            name="message"
            rows="5"
            placeholder="Type your message or queries..."
            value={formData.message}
            onChange={handleChange}
            required
          ></textarea>

          {/* Turnstile Widget */}
          <div id="turnstile-widget"></div>

          <label className="terms-check">
            <input
              type="checkbox"
              checked={agree}
              onChange={() => setAgree(!agree)}
            />
            I agree to the{" "}
            <a
              href="/terms-conditions"
              className="terms-link"
              target="_blank"
              rel="noopener noreferrer"
            >
              Terms & Conditions
            </a>
          </label>

          {errorMsg && <p className="form-error">{errorMsg}</p>}
          {serverMsg && <p className="form-success">{serverMsg}</p>}

          <button type="submit" disabled={!agree || loading}>
            {loading ? "Submitting..." : "Submit"}
          </button>
        </form>
      </div>

      <div className="faq-section">
        <h2>Frequently Asked Questions</h2>

        {faqs.map((faq, index) => (
          <div className="faq-item" key={index}>
            <div className="faq-question" onClick={() => toggleFAQ(index)}>
              {faq.question}
            </div>

            {openFaqIndex === index && (
              <div className="faq-answer">{faq.answer}</div>
            )}
          </div>
        ))}
      </div>
    </div>
  );
};

export default Contact;